const PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || "yvf9f869qf";
const SCRIPT_ID = "microsoft-clarity-script";
export const CONSENT_KEY = "swedcro-cookie-consent";
export const CONSENT_EVENT = "swedcro:cookie-consent-changed";
export const OPEN_SETTINGS_EVENT = "swedcro:open-cookie-settings";

export const readConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveConsent = (statistics) => {
  const value = { statistics: !!statistics, ts: new Date().toISOString() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  return value;
};

const ensureStub = () => {
  window.clarity =
    window.clarity ||
    function (...args) {
      (window.clarity.q = window.clarity.q || []).push(args);
    };
};

export const loadClarity = () => {
  if (!PROJECT_ID || document.getElementById(SCRIPT_ID)) return;
  ensureStub();
  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(PROJECT_ID)}`;
  script.onload = () => window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "granted" });
  script.onerror = () => console.warn("Microsoft Clarity failed to load");
  document.head.appendChild(script);
};

export const revokeClarity = () => {
  if (typeof window.clarity === "function") {
    window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "denied" });
  }
  document.getElementById(SCRIPT_ID)?.remove();
};

export const clarityEvent = (name) => {
  if (typeof window.clarity === "function") window.clarity("event", name);
};

export const clarityTag = (key, value) => {
  if (typeof window.clarity === "function") window.clarity("set", key, value);
};
